```vue
<template>
  <div class="lesson-container">
    <!-- Header -->
    <div class="lesson-header d-flex justify-content-between align-items-center">
      <h3>{{ lessonData.title }}</h3>
      <div class="card-profile-actions" style="display: flex; flex-direction: column; width: 250px;">
        <div class="d-flex justify-content-between align-items-center w-100">
          <h3 v-if="lessonData.average_rating" class="mr-3">{{ lessonData.average_rating }}<i class="fa fa-star"></i></h3>
          <h3 v-if="formattedPrice != 0" >{{ formattedPrice }}₮</h3>
        </div>
        <base-button v-if="user_state.is_creator || getUser.user_type === 3" type="default" size="sm" @click="handleEdit">
          <span class="nav-link-inner--text">Засах</span>
        </base-button>
        <base-button v-else-if="user_state.is_subscribed" type="info" size="sm">
          <span class="nav-link-inner--text">Худалдаж авсан</span>
        </base-button>
        <base-button v-else-if="formattedPrice == '0'" type="info" size="sm">
          <span class="nav-link-inner--text">Үнэгүй</span>
        </base-button>
        <base-button v-else type="info" size="sm" @click="handlePay">
          <span class="nav-link-inner--text">Худалдаж авах</span>
        </base-button>
      </div>
    </div>

    <!-- Main Content -->
    <div class="lesson-content-wrapper">
      <div class="content-left">
        <img v-if="showImage" :src="lessonData.imageUrl" class="lesson-media rounded shadow" />
        <vimeo-player v-else ref="vimeoPlayer" :video-id="currentVideoId" :options="{
          title: false,
          byline: false,
          portrait: false,
          controls: true,
          dnt: true,
          loop: false,
          autoplay: true,
          transparent: false,
          responsive: true
        }" class="lesson-media" @ready="onPlayerReady" />
      </div>
      <div class="content-right">
        <table class="table">
          <tbody>
            <tr @click="showLessonImage">
              <td><h6>Info</h6></td>
              <td class="text-right"></td>
            </tr>
            <tr v-for="sublesson in lessonData.sub_lessons" :key="sublesson.id" style="width: max-content;">
              <td><h6>{{ sublesson.title }}</h6></td>
              <td class="text-right">
                <div v-if="user_state.is_creator || getUser.user_type === 3 || user_state.is_subscribed || formattedPrice == 0">
                  <base-button v-if="sublesson.pdf_path" type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title="" style="margin-right: 0;" title="" @click="downloadPdf(sublesson)">
                    <i class="fa fa-file-pdf-o pt-1"></i>
                  </base-button>
                  <base-button v-if="sublesson.video_embed_url" type="button" rel="tooltip" class="btn btn-success btn-icon btn-sm" data-original-title="" title="" @click="playVideo(sublesson)">
                    <i class="fa fa-play pt-1"></i>
                  </base-button>
                </div>
                <div v-else>
                  <base-button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title="" title="">
                    <i class="fa fa-lock pt-1"></i>
                  </base-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Other Info - Left-aligned as ul li -->
    <div class="lesson-info">
      <h4>Хичээлийн тухай</h4>
      <h6 class="m-3" v-if="lessonData.content">
        <span v-for="(line, index) in lessonData.content.split('<b>')" :key="index">
          {{ line }}<br>
        </span>
      </h6>
      <h4 v-if="lessonData.learningItems && lessonData.learningItems.length">Би юу сурах вэ?</h4>
      <ul class="m-3">
        <li v-for="(item, index) in lessonData.learningItems" :key="index">
          <h6>{{ item }}</h6>
        </li>
      </ul>
    </div>

    <!-- Comment Section -->
    <div class="comments-section">
      <h4>Сэтгэгдэл</h4>
      <div v-if="comments.length">
        <div v-for="comment in comments" :key="comment.id" class="comment">
          <p>
            <strong>{{ comment.user_firstname ? comment.user_firstname : "Anonymous" }}</strong>
            <span v-if="comment.rate">
              | Оноо:
              <span class="rating-stars">
                <template v-for="n in 5">
                  <i class="fa" :class="n <= comment.rate ? 'fa-star' : 'fa-star-o'"></i>
                </template>
              </span>
              ({{ comment.rate }})
            </span>
            <span class="ml-3">
              {{ new Date(comment.created_at).toLocaleString('mn-MN', {
                year: 'numeric', month: '2-digit', day: '2-digit'
              }).replace(',', '') }}
            </span>
            <base-button v-if="getUser.user_type === 3" type="danger" size="sm" @click="deleteComment(comment.id)" class="float-right">
              <i class="fa fa-trash"></i>
            </base-button>
            <br>
            <span>{{ comment.text }}</span>
          </p>
        </div>
      </div>
      <div v-else>
        <p>Сэтгэгдэл байхгүй байна.</p>
      </div>
      <form v-if="user_state.is_subscribed" @submit.prevent="submitComment">
        <textarea v-model="newComment" class="form-control" placeholder="Сэтгэгдэл үлдээнэ үү..." required style="height: 100px; resize: none;"></textarea>
        <div class="form-group mt-2">
          <label for="rating">Оноо (1-5):</label>
          <select id="rating" v-model="newRating" class="form-control" required>
            <option disabled value="">Сонгоно уу</option>
            <option value="5"> Маш сайн </option>
            <option value="4"> Сайн </option>
            <option value="3"> Хангалттай </option>
            <option value="2"> Муу </option>
            <option value="1"> Маш муу </option>
          </select>
        </div>
        <button type="submit" class="btn btn-info btn-sm">Нэмэх</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { vueVimeoPlayer as VimeoPlayer } from "vue-vimeo-player";

export default {
  name: "Lesson",
  components: {
    VimeoPlayer,
  },
  data() {
    return {
      lessonData: {},
      user_state: {},
      currentVideoId: "",
      showImage: true,
      comments: [],
      newComment: "",
      newRating: "",
      vimeoOptions: {
        autoplay: true,
        muted: true,
        controls: true,
        responsive: true,
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    formattedPrice() {
      return new Intl.NumberFormat("mn-MN").format(this.lessonData.price || 0);
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    handleEdit() {
      this.$router.push(`/lesson/edit/${this.lessonData.id}`);
    },
    handlePay() {
      this.$router.push(`/pay/${this.lessonData.id}`);
    },
    fetchLessonData() {
      const id = this.$route.params.id;
      axios.get(`/lesson/${id}`).then((response) => {
        this.lessonData = response.data.lesson;
        this.user_state = response.data.user_status;
        this.fetchComments();
      });
    },
    playVideo(sublesson) {
      this.showImage = false;
      this.currentVideoId = this.extractVimeoId(
        `${sublesson.video_embed_url}?title=0&byline=0&portrait=0&transparent=0&autoplay=1&show_related=0`
      );
    },
    extractVimeoId(url) {
      const match = url.match(/(?:vimeo\.com\/|video\/)(\d+)/);
      return match ? match[1] : null;
    },
    onPlayerReady() {
      console.log("Vimeo player is ready");
      const player = this.$refs.vimeoPlayer;
      player.play().catch((error) => {
        console.error("Error playing video:", error);
      });
    },
    downloadPdf(sub_lesson) {
      axios
        .get(`/sub_lesson/file/${sub_lesson.id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = sub_lesson.generated_name || `lesson-${sub_lesson.id}.pdf`;
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error downloading PDF:", error);
          throw new Error("Failed to download PDF");
        });
    },
    showLessonImage() {
      this.showImage = true;
    },
    fetchComments() {
      const id = this.$route.params.id;
      axios
        .get(`/lesson/${id}/comments`)
        .then((response) => {
          this.comments = response.data;
        })
        .catch((error) => {
          console.error("Error fetching comments:", error);
        });
    },
    submitComment() {
      if (!this.newComment || !this.newRating) {
        alert("Сэтгэгдэл болон оноо оруулна уу.");
        return;
      }
      const id = this.$route.params.id;
      axios
        .post(`/lesson/${id}/comments`, { text: this.newComment, rate: this.newRating })
        .then((response) => {
          this.comments.push(response.data);
          this.newComment = "";
          this.newRating = "";
          this.fetchLessonData();
        })
        .catch((error) => {
          console.error("Error submitting comment:", error);
        });
    },
    deleteComment(commentId) {
      axios
        .delete(`/comments/${commentId}`)
        .then(() => {
          this.comments = this.comments.filter((c) => c.id !== commentId);
        })
        .catch((error) => {
          console.error("Error deleting comment:", error);
        });
    },
  },
  created() {
    this.fetchLessonData();
  },
};
</script>

<style scoped>
.lesson-container {
  padding: 20px;
}

.lesson-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-profile-actions {
  display: flex;
  flex-direction: column;
  width: 250px;
  gap: 10px;
}

.lesson-content-wrapper {
  display: flex;
  gap: 20px;
}

.content-left {
  flex: 7;
  position: relative;
}

.content-right {
  flex: 3;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.lesson-media {
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.lesson-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lesson-media-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
}

.lesson-media-container iframe,
.lesson-media-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.lesson-info {
  margin-top: 20px;
  text-align: left;
}

.lesson-info ul {
  padding-left: 20px;
  margin-top: 10px;
}

.lesson-info li {
  margin-bottom: 8px;
}

table {
  width: 100%;
}

.text-right {
  text-align: right;
}

.comments-section {
  margin-top: 40px;
  padding: 20px;
  border-top: 1px solid #ccc;
}

.comments-section h4 {
  margin-bottom: 20px;
}

.comment {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ccc;
}

.comment-form {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.comment-form textarea {
  resize: vertical;
  min-height: 80px;
  margin-bottom: 10px;
  padding: 10px;
  font-size: 14px;
}

/* Tablet screens (max-width: 768px) */
@media (max-width: 768px) {
  .lesson-container {
    padding: 15px;
  }

  .lesson-header {
    flex-direction: row;
    align-items: flex-start;
    gap: 15px;
  }

  .card-profile-actions {
    width: 100px !important;
  }

  .lesson-content-wrapper {
    flex-direction: column;
    gap: 15px;
  }

  .content-left,
  .content-right {
    flex: 1;
  }

  .content-right {
    height: 300px;
  }

  .lesson-info {
    margin-top: 15px;
  }

  .lesson-info h4,
  .comments-section h4 {
    font-size: 1.2rem;
  }

  .comments-section {
    margin-top: 30px;
    padding: 15px;
  }

  .comment-form textarea {
    font-size: 13px;
  }

  .btn-sm {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
}

/* Mobile screens (max-width: 480px) */
@media (max-width: 480px) {
  .lesson-container {
    padding: 10px;
  }

  .lesson-header {
    gap: 10px;
  }

  .lesson-header h3 {
    font-size: 1.2rem;
  }

  .card-profile-actions {
    width: 100px !important;
  }

  .card-profile-actions h3 {
    font-size: 1rem;
  }

  .lesson-content-wrapper {
    gap: 10px;
  }

  .content-right {
    height: 250px;
  }

  .lesson-info {
    margin-top: 10px;
  }

  .lesson-info h4,
  .comments-section h4 {
    font-size: 1rem;
  }

  .lesson-info h6,
  .comments-section p,
  .comment-form textarea {
    font-size: 0.9rem;
  }

  .comments-section {
    margin-top: 20px;
    padding: 10px;
  }

  .comment-form textarea {
    min-height: 60px;
  }

  .btn-sm {
    font-size: 0.7rem;
    padding: 4px 8px;
  }

  table h6 {
    font-size: 0.9rem;
  }
}
</style>
```